module.exports = __webpack_public_path__ + "staticcomp/img/content_2.7ba14f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/7/content_2.jpg
// module id = EiRS
// module chunks = 39